import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"

import SiteHeader from "../../components/SiteHeader"
import SiteHeaderSpacer from "../../components/SiteHeaderSpacer"
import ContactUpdate from "../../forms/ContactUpdate"

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    margin: "auto",
    marginTop: theme.spacing(5),
    maxWidth: 600,
  },
}))

const ProfileEdit = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <SiteHeader fullWidth logo title="Profile" global />
      <SiteHeaderSpacer />
      <Grid className={classes.container} container spacing={3}>
        <Grid item xs={12}>
          <ContactUpdate />
        </Grid>
      </Grid>
    </div>
  )
}

export default ProfileEdit
